<template>
  <div
    class="border mt-1 rounded max-h-[90vh] p-2 text-xl min-w-[22.7%] mx-1 text-left px-4 py-3"
    :class="[
      hTraba
        ? 'text-[#009285] border-2 border-[#009285] bg-[#00928620]'
        : '',
      hDeved
        ? 'text-[#920000] border-2 border-[#920000] bg-[#f1dfdf]'
        : '',
      hExtras
        ? 'text-[#99c537] border-2 border-[#99c537] bg-[#b3d04220]'
        : '',
      faltas
        ? 'text-[#920000] border-2 border-[#920000] bg-[#f1dfdf]'
        : '',
    ]"
  >
    <h1>
      <span class="font-semibold">
        {{ props.value }}
      </span>
      <br />
      <div class="flex flex-col">
        <span class="text-gray-500 text-base">
          {{ props.label }}
        </span>
        <small class="text-gray-400 text-xs" v-if="byMount"> 
          Neste mes 
        </small>
        <small class="text-gray-400 text-xs" v-else-if="total"> 
          Total
        </small>
      </div>
    </h1>
  </div>
</template>

<script setup>
const props = defineProps({
  label: String,
  value: [String, Number],
  total: { Boolean, default: false },
  byMount: { Boolean, default: true },
  hTraba:  { Boolean, default: false },
  hDeved:  { Boolean, default: false },
  hExtras: { Boolean, default: false },
  faltas:  { Boolean, default: false },
});
</script>
